export default __webpack_public_path__ + "static/media/bg3.ee120390.png";